export const roomTypeColumn = [
  {
    Header: "S.No",
    accessor: "roomTypeId",
  },
  {
    Header: "Room Type",
    accessor: "roomTypeName",
  },
  {
    Header: "Actions",
    accessor: "actions",
  },
];

export const roomTypeTableData = [
  {
    id: "1",
    roomType: "Vip-Guest",
    roomPrice: "4000",
    bedCharge: "100",
    capacity: "3",
    roomSize: "King",
    bedNo: "2",
    bedType: "Standard Double",
  },
  {
    id: "2",
    roomType: "Vip",
    roomPrice: "10000",
    bedCharge: "400",
    capacity: "20",
    roomSize: "King",
    bedNo: "1",
    bedType: "Electric Bed",
  },
  {
    id: "3",
    roomType: "Family Room",
    roomPrice: "4500",
    bedCharge: "150",
    capacity: "4",
    roomSize: "Queen",
    bedNo: "2",
    bedType: "Standard Queen",
  },
  {
    id: "4",
    roomType: "Deluxe Suite",
    roomPrice: "5500",
    bedCharge: "130",
    capacity: "3",
    roomSize: "King",
    bedNo: "1",
    bedType: "Luxury King",
  },
  {
    id: "5",
    roomType: "Standard Room",
    roomPrice: "3000",
    bedCharge: "80",
    capacity: "2",
    roomSize: "Queen",
    bedNo: "1",
    bedType: "Standard Queen",
  },
  {
    id: "6",
    roomType: "Signal Room",
    roomPrice: "2500",
    bedCharge: "70",
    capacity: "1",
    roomSize: "Twin",
    bedNo: "1",
    bedType: "Standard Twin",
  },
  {
    id: "7",
    roomType: "Executive Room",
    roomPrice: "4500",
    bedCharge: "110",
    capacity: "2",
    roomSize: "Queen",
    bedNo: "2",
    bedType: "Luxury Queen",
  },
  {
    id: "8",
    roomType: "Presidential Suite",
    roomPrice: "8000",
    bedCharge: "200",
    capacity: "6",
    roomSize: "King",
    bedNo: "3",
    bedType: "Luxury King",
  },
  {
    id: "9",
    roomType: "Double Room",
    roomPrice: "3500",
    bedCharge: "90",
    capacity: "2",
    roomSize: "King",
    bedNo: "1",
    bedType: "Standard King",
  },
  {
    id: "10",
    roomType: "Family Suite",
    roomPrice: "6000",
    bedCharge: "160",
    capacity: "5",
    roomSize: "King",
    bedNo: "2",
    bedType: "Luxury King",
  },
  {
    id: "11",
    roomType: "Junior Suite",
    roomPrice: "4800",
    bedCharge: "140",
    capacity: "3",
    roomSize: "Queen",
    bedNo: "1",
    bedType: "Luxury Queen",
  },
  {
    id: "12",
    roomType: "King Suite",
    roomPrice: "7000",
    bedCharge: "180",
    capacity: "4",
    roomSize: "King",
    bedNo: "2",
    bedType: "Luxury King",
  },
  {
    id: "13",
    roomType: "Twin Room",
    roomPrice: "3200",
    bedCharge: "85",
    capacity: "2",
    roomSize: "Twin",
    bedNo: "2",
    bedType: "Standard Twin",
  },
];
